<div class="content flex hcenter vcenter">
  <h1>{{ "EHAZ_SSO_ERROR.MESSAGE" | translate }}</h1>
</div>
